export default __webpack_public_path__ + "static/ASCO_logo-e507352fe9a53798a8f68408c72c2ee9.png";